<template>
  <div class="content-subsection">
    <h1>{{ subsection.method }}</h1>
    <h2>Installation Method</h2>
    <div class="installation-desc mt-5">
      <v-rich-text-renderer :value="subsection.text" />
    </div>
    <div class="columns mt-5">
      <div class="column is-4 checked-list installation-list">
        <v-rich-text-renderer :value="subsection.list" />
      </div>
      <div class="column is-8">
        <img 
          :src="subsection.image.url" 
          :alt="subsection.image.name" 
          class="installation-method-img exception" 
        />
      </div>
    </div>
  </div>
</template>

<script>
import VRichTextRenderer from '../base/VRichTextRenderer'

export default {
  props: {
    subsection: {
      type: Object,
      required: true
    }
  },
  components: { VRichTextRenderer }
}
</script>

<style lang="scss" scoped>
.installation-desc {
  width: 75%;
}
.installation-list {
  font-size: 0.85em;
}
.installation-method-img {
  width: 100%;
  max-height: 500px;
  margin-top: 80px;
}
</style>

